jQuery(function ($) {
  const Scripts = {
    headerScripts() {
      const body = document.querySelector("body");
      const header = document.querySelector(".header");
      const burger = header.querySelector(".header__burger");
      const menu = header.querySelector(".header__menu");
      const searchToggle = header.querySelector("#search-btn");
      const searchDialog = document.querySelector("#search-dialog");
      const searchForm = document.querySelector(".search-form__container");
      const searchInput = document.querySelector(".search-form__input");
      const searchClose = document.querySelector(".search-form__close");
      const dropdownList = document.querySelectorAll(".menu-item-has-children");
      let dropdownInitialized = false;

      function openSearch() {
        body.classList.remove("menu-open");
        body.classList.add("search-open");

        searchDialog.hidden = false;
        searchToggle.setAttribute("aria-expanded", "true");

        searchInput?.focus();
      }

      function closeSearch() {
        body.classList.remove("search-open");

        searchDialog.hidden = true;
        searchToggle?.setAttribute("aria-expanded", "false");
        searchToggle?.focus();
      }

      function openMenu() {
        body.classList.remove("search-open");
        body.classList.add("menu-open");

        burger.setAttribute("aria-expanded", "true");
      }

      function closeMenu() {
        body.classList.remove("menu-open");

        burger.setAttribute("aria-expanded", "false");
      }

      // Menu
      burger.addEventListener("click", () => {
        const isOpen = body.classList.contains("menu-open");

        if (isOpen) {
          closeMenu();
        } else {
          closeSearch();
          openMenu();
        }
      });

      // Show/Hide Popup
      searchToggle?.addEventListener("click", () => {
        const isSearchActive = body.classList.contains("search-open");
        const isSearchResults = body.classList.contains("search");

        if (isSearchResults) {
          searchInput?.focus();
          const length = searchInput?.value.length || 0;
          searchInput?.setSelectionRange(length, length);
          return;
        }

        if (isSearchActive) {
          closeSearch();
        } else {
          closeMenu();
          openSearch();
        }
      });

      // Close Search by overlay
      document.addEventListener("click", (e) => {
        if (
          body.classList.contains("search-open") &&
          e.target &&
          !searchForm?.contains(e.target) &&
          !header?.contains(e.target)
        ) {
          closeSearch();
        }
      });

      searchClose?.addEventListener("click", (e) => {
        closeSearch();
      });

      // // Resize observing
      // window.addEventListener("resize", debounce(() => {
      //     if (window.innerWidth < 1365) {
      //         toggleDropdownMenu();
      //     } else {
      //         body.classList.remove("menu-open");
      //     }
      // }, 200));

      function toggleDropdownMenu() {
        if (dropdownInitialized) return;
        dropdownInitialized = true;

        dropdownList?.forEach((child) => {
          child.addEventListener("click", (e) => {
            if (e.target.parentElement == child) {
              e.preventDefault();
              child.classList.toggle("show-mob-submenu");
            }
          });
        });
      }

      // function debounce(func, delay) {
      //     let timeout;
      //     return function () {
      //         clearTimeout(timeout);
      //         timeout = setTimeout(func, delay);
      //     };
      // }

      // Initial run
      if (window.innerWidth <= 1365) {
        toggleDropdownMenu();
      }
    },

    headerScroll() {
      const $window = $(window);
      const $header = $(".header");
      const scrollThreshold = 20;

      const toggleHeaderScrolled = function () {
        const isScrolled = $window.scrollTop() > scrollThreshold;
        $header.toggleClass("header--scrolled", isScrolled);
      };

      // Init state when page is loaded.
      toggleHeaderScrolled();

      $window.on("scroll", toggleHeaderScrolled);
    },

    itemsObserver() {
      const activeItems = document.querySelectorAll(".js-observe");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in-view");

              if (entry.target.classList.contains("statistics")) {
                Scripts.statisticsAnimationBymbers(entry.target);
              }
            } else {
              entry.target.classList.remove("in-view");
            }
          });
        },
        {
          threshold: 0.2,
        },
      );

      activeItems.forEach((activeItem) => observer.observe(activeItem));
    },

    initSliders() {
      const aboutSlider = document.querySelector(".about-slider");
      const fundGoalsSlider = document.querySelector(".fund-goals-slider");

      function setMaxSliderHeight(swiper) {
        let maxHeight = 0;

        $(swiper.slides).each((i, slide) => {
          const height = $(slide).outerHeight(true);
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        $(swiper.el).css("height", maxHeight + "px");
      }

      function markPrevSlides(swiper) {
        const $slides = $(swiper.slides);

        $slides.removeClass("_prev");

        $slides.each((index, slide) => {
          if (index < swiper.activeIndex) {
            $(slide).addClass("_prev");
          }
        });
      }

      if (aboutSlider) {
        const slider = new Swiper(".about-slider", {
          slidesPerView: 1.02,
          centeredSlides: false,
          spaceBetween: 14,
          a11y: true,
          loop: true,
          loopAdditionalSlides: 2,
          speed: 1000,
          effect: "slide",
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 0.8,
          },
          navigation: {
            nextEl: ".about__controls-next",
            prevEl: ".about__controls-prev",
          },
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 24,
            },
          },
          pagination: {
            el: ".about__controls-progressbar",
            type: "progressbar",
          },
          on: {
            init(swiper) {
              setMaxSliderHeight(swiper);
            },
            imagesReady(swiper) {
              setMaxSliderHeight(swiper);
            },
            resize(swiper) {
              setMaxSliderHeight(swiper);
            },
            slideChange(swiper) {
              markPrevSlides(swiper);
            },
          },
        });
      }

      if (fundGoalsSlider) {
        const swiper = new Swiper(".fund-goals-slider", {
          slidesPerView: "auto",
          spaceBetween: 14,
          centeredSlides: false,
          loop: true,
          loopAdditionalSlides: 1.5,
          a11y: true,
          initialSlide: 0,
          autoHeight: false,
          speed: 1000,
          effect: "slide",
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: false,
            sensitivity: 0.8,
          },
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          navigation: {
            prevEl: ".fund-goals__controls-prev",
            nextEl: ".fund-goals__controls-next",
          },
          pagination: {
            el: ".fund-goals__controls-progressbar",
            type: "progressbar",
          },
          breakpoints: {
            1024: {
              initialSlide: 2,
              spaceBetween: 20,
            },
          },
          on: {
            init(swiper) {
              setMaxSliderHeight(swiper);
              markPrevSlides(swiper);
            },
            slideChange(swiper) {
              markPrevSlides(swiper);
            },
          },
        });
      }
    },

    spollers() {
      const allFaqItems = $("details");

      allFaqItems.each(function () {
        const faqItem = $(this);
        const question = faqItem.find("summary");
        const answer = question.next();

        if (faqItem.prop("open")) {
          answer.show();
        } else {
          answer.hide();
        }

        question.on("click", function (e) {
          e.preventDefault();

          const isOpen = faqItem.prop("open");

          if (isOpen) {
            answer.slideUp(200, function () {
              faqItem.prop("open", false);
            });
          } else {
            // close all other opened items first
            allFaqItems.not(faqItem).each(function () {
              const otherItem = $(this);
              if (otherItem.prop("open")) {
                otherItem
                  .find("summary")
                  .next()
                  .slideUp(200, function () {
                    otherItem.prop("open", false);
                  });
              }
            });

            faqItem.prop("open", true);
            answer.slideDown(300);
          }
        });
      });
    },

    copyValue() {
      const copyItems = document.querySelectorAll("[data-copy]");

      document.addEventListener("click", function (e) {
        const target = e.target.closest("[data-copy]");

        if (!target) return;

        const copyType = target.dataset.copy;
        const parent = copyType === "button" ? target : target.parentElement;
        let value;

        if (copyType === "button") {
          value = parent.getAttribute("data-copy-value");
        } else {
          value = parent.querySelector("a")?.textContent?.trim();
        }

        if (!value) return;

        copyItems.forEach((copyItem) =>
          copyItem.parentElement?.classList.remove("copied"),
        );

        parent.classList.add("copied");

        setTimeout(() => {
          parent.classList.remove("copied");
        }, 3000);

        navigator.clipboard
          .writeText(value)
          .then(() => console.log("Text copied to clipboard"))
          .catch((err) => console.error("Copy failed:", err));
      });
    },

    statisticsAnimationBymbers(container) {
      if (!container || container.dataset.counted === "true") return;

      const statisticValues = container.querySelectorAll(
        ".statistics__item-value b",
      );
      if (!statisticValues.length) return;

      const animateCounter = (element) => {
        const originalText = (element.textContent || "").trim();
        const match = originalText.match(/-?\d[\d\s.,]*/);

        if (!match) return;

        const numericPart = match[0];
        const startIndex = match.index ?? 0;
        const prefix = originalText.slice(0, startIndex);
        const suffix = originalText.slice(startIndex + numericPart.length);

        const normalized = numericPart.replace(/\s/g, "").replace(",", ".");
        const targetValue = Number.parseFloat(normalized);

        if (Number.isNaN(targetValue)) return;

        const decimalMatch = numericPart.match(/[.,](\d+)/);
        const decimalPlaces = decimalMatch ? decimalMatch[1].length : 0;
        const duration = 1400;
        const startTime = performance.now();

        const formatNumber = (value) => {
          const absValue = Math.abs(value);
          const rounded = Number.parseFloat(absValue.toFixed(decimalPlaces));

          return rounded.toLocaleString("uk-UA", {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
          });
        };

        const step = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 3);
          const currentValue = targetValue * easedProgress;

          element.textContent = `${prefix}${formatNumber(
            currentValue,
          )}${suffix}`;

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            element.textContent = originalText;
          }
        };

        requestAnimationFrame(step);
      };

      statisticValues.forEach((item) => animateCounter(item));
      container.dataset.counted = "true";
    },

    filters() {
      const filter = document.querySelector("[data-cpt]");
      let postType = filter?.getAttribute("data-cpt");
      const currentTax = filter?.getAttribute("data-current-tax");
      const currentTerm = filter?.getAttribute("data-current-term");
      const titleTag = filter?.getAttribute("data-card-title-tag");
      const taxonomiesContainer = document.querySelector(
        ".archive-filter__taxonomies",
      );
      const taxonomies = document.querySelectorAll("[data-tax]");
      const resetBtnsContainer = document.querySelector(
        ".archive-filter__reset-btns",
      );

      /** Поєднуємо функціонал фільтрації з асинхронним підвантаженням
       *  для синглової сторінки Програми
       */
      const $moreButton = $(".program-news__load-more");
      const hideProgram = $moreButton.attr("data-hide-program");

      let checkedIDs = {};

      // _checkActiveFilters();

      function closeTermsList(taxonomy) {
        const toggleButton = taxonomy.querySelector(".js-filter-toggle-button");
        const termsWrapper = taxonomy.querySelector(
          ".archive-filter__terms-wrapper",
        );

        taxonomy.classList.remove("terms-opened");

        if (toggleButton) {
          toggleButton.setAttribute("aria-expanded", "false");
        }

        if (termsWrapper) {
          termsWrapper.hidden = true;
        }
      }

      function openTermsList(taxonomy) {
        const toggleButton = taxonomy.querySelector(".js-filter-toggle-button");
        const termsWrapper = taxonomy.querySelector(
          ".archive-filter__terms-wrapper",
        );

        taxonomy.classList.add("terms-opened");

        if (toggleButton) {
          toggleButton.setAttribute("aria-expanded", "true");
        }

        if (termsWrapper) {
          termsWrapper.hidden = false;
        }
      }

      function toggleTermsList(taxonomy) {
        const isOpened = taxonomy.classList.contains("terms-opened");

        taxonomies.forEach((item) => {
          if (item !== taxonomy) {
            closeTermsList(item);
          }
        });

        if (isOpened) {
          closeTermsList(taxonomy);
        } else {
          openTermsList(taxonomy);
        }
      }

      function syncRadioButtonsState(taxonomy, activeButton) {
        const buttons = taxonomy.querySelectorAll(".js-filter-option-button");

        buttons.forEach((button) => {
          button.classList.remove("is-active");
          button.setAttribute("aria-pressed", "false");
        });

        activeButton.classList.add("is-active");
        activeButton.setAttribute("aria-pressed", "true");
      }

      // Handlers
      //* Init Taxonomies
      taxonomies.forEach((taxonomy) => {
        taxonomy.addEventListener("click", (e) => {
          const toggleButton = e.target.closest(".js-filter-toggle-button");
          const optionButton = e.target.closest(".js-filter-option-button");

          if (toggleButton && taxonomy.contains(toggleButton)) {
            toggleTermsList(taxonomy);
            return;
          }

          if (optionButton && taxonomy.contains(optionButton)) {
            handleTermsSelection(taxonomy, optionButton);
          }
        });
      });

      //* Chosen taxonomy term
      resetBtnsContainer?.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-reset-tax][data-reset-slug]");
        if (!btn) return;

        const taxName = btn.getAttribute("data-reset-tax");
        const taxonomy = document.querySelector(`[data-tax="${taxName}"]`);
        if (!taxonomy) return;

        const allTermEl = taxonomy.querySelector('[data-term-slug="all"]');

        $moreButton.attr("data-category", "all");
        $moreButton.attr("data-post-tag", "all");

        if (!allTermEl) return;

        handleTermsSelection(taxonomy, allTermEl);
      });

      //* Close taxonomy list by overlay
      document.addEventListener("click", (e) => {
        const isClickInside = Array.from(taxonomies).some((taxonomy) =>
          taxonomy.contains(e.target),
        );
        const openedTerms = document.querySelector(".terms-opened");

        if (!isClickInside && openedTerms) {
          taxonomies.forEach(closeTermsList);
        }
      });

      //* Remove all checked terms (Single taxonomy)
      function _removeCheckedTerms(taxonomy) {
        const terms = taxonomy.querySelectorAll(".checked");

        terms.forEach((term) => term.classList.remove("checked"));
      }

      function handleTermsSelection(taxonomy, currentTerm) {
        const taxName = taxonomy.getAttribute("data-tax");
        const isMultiselect = !!taxonomy.querySelector(
          ".archive-filter__terms--checkbox",
        );

        !checkedIDs[taxName] && (checkedIDs[taxName] = []);

        if (isMultiselect) {
          _handleCheckboxSelection(taxonomy, currentTerm);
        } else {
          _handleRadioSelection(taxonomy, currentTerm);
          syncRadioButtonsState(taxonomy, currentTerm);
        }

        closeTermsList(taxonomy);
        renderResetButtons();
        fetchPosts();
      }

      //* Multiple choice (CHECKBOXES)
      function _handleCheckboxSelection(taxonomy, currentTerm) {
        const taxName = taxonomy.getAttribute("data-tax");
        const parentTermSlug = currentTerm.getAttribute("data-parent-slug");
        const termSlug = currentTerm.getAttribute("data-term-slug");
        const isChecked = checkedIDs[taxName].includes(termSlug);

        if (isChecked) {
          // Remove term
          checkedIDs[taxName].splice(termIndex, 1);
          currentTerm.classList.remove("checked");

          // Return parent if no childs
          if (checkedIDs[taxName].length === 0) {
            checkedIDs[taxName].push(parentTermSlug);
          }
        } else {
          // Add term
          checkedIDs[taxName].push(termSlug);
          currentTerm.classList.add("checked");
        }
      }

      //* Single choice (RADIO GROUP)
      function _handleRadioSelection(taxonomy, currentTerm) {
        const taxName = taxonomy.getAttribute("data-tax");
        const termSlug = currentTerm.getAttribute("data-term-slug");

        $(currentTerm)[0].scrollIntoView({
          behavior: "smooth",
          inline: "nearest",
          block: "nearest",
        });

        if (taxName === "category") {
          $moreButton.attr("data-category", termSlug);
        }
        if (taxName === "post_tag") {
          $moreButton.attr("data-post-tag", termSlug);
        }

        // Regions
        if (taxName === "rada-region") {
          const regions = document.querySelectorAll(".map-regions g");
          const region = document.querySelector(
            `.map-regions [data-slug="${termSlug}"]`,
          );

          regions.forEach((region) => region.classList.remove("active"));

          if (region) {
            region.classList.add("active");
          }
        }

        // Types (remove childs)
        if (taxName === "case-type") {
          document.querySelectorAll("[data-parent-slug]").forEach((checked) => {
            checked.classList.remove("checked");
          });
        }

        if (termSlug === "all") {
          _removeCheckedTerms(taxonomy);
          delete checkedIDs[taxName];
        } else {
          checkedIDs[taxName] = [termSlug];
          _removeCheckedTerms(taxonomy);
          currentTerm.classList.add("checked");
        }
      }

      //* Create params string
      function _createFilterQueryString() {
        let queryParts = [];
        // if (postType === 'post') postType = 'news';

        Object.keys(checkedIDs).forEach((key) => {
          if (checkedIDs[key].length > 0) {
            queryParts.push(`${key}=${checkedIDs[key].join(",")}`);
          }
        });

        return queryParts.length > 0 ? "?" + queryParts.join("&") : "";
      }

      function _checkActiveFilters() {
        const allowedParams = [
          "category",
          "program",
          "post_tag",
          "contest-type",
          "material-type",
          "lang",
        ];

        const urlParams = new URLSearchParams(window.location.search);

        const activeParams = Array.from(urlParams.entries()).filter(
          ([key, value]) => allowedParams.includes(key) && value,
        );

        if (!activeParams.length) {
          const taxonomy =
            document.querySelector('[data-tax="material-type"]') ??
            document.querySelector('[data-tax="contest-type"]');

          const allButton = taxonomy?.querySelector('[data-term-slug="all"]');

          if (taxonomy && allButton) {
            syncRadioButtonsState(taxonomy, allButton);
          }

          renderResetButtons();
          return;
        }

        activeParams.forEach(([taxName, value]) => {
          if (taxName === "category") {
            $moreButton.attr("data-category", value);
          }

          if (taxName === "post_tag") {
            $moreButton.attr("data-post-tag", value);
          }

          if (!checkedIDs[taxName]) {
            checkedIDs[taxName] = [];
          }

          value.split(",").forEach((termSlug) => {
            if (!termSlug) return;

            const matchedTerms = document.querySelectorAll(
              `[data-tax="${taxName}"] [data-term-slug="${termSlug}"]`,
            );

            matchedTerms.forEach((matchedTerm) => {
              matchedTerm.classList.add("checked");

              const taxonomy = matchedTerm.closest("[data-tax]");

              if (
                taxonomy &&
                !taxonomy.querySelector(".archive-filter__terms--checkbox")
              ) {
                syncRadioButtonsState(taxonomy, matchedTerm);
              }
            });

            if (!checkedIDs[taxName].includes(termSlug)) {
              checkedIDs[taxName].push(termSlug);
            }
          });
        });

        renderResetButtons();
      }

      function renderResetButtons() {
        if (!resetBtnsContainer) return;

        const fragments = [];

        Object.entries(checkedIDs).forEach(([taxName, slugs]) => {
          (slugs || []).forEach((slug) => {
            if (!slug || slug === "all") return;

            const termEl = document.querySelector(
              `[data-tax="${taxName}"] [data-term-slug="${slug}"]`,
            );
            if (!termEl) return;

            const termName = (termEl.textContent || "").trim();
            if (!termName) return;

            fragments.push(`
							<button type="button" data-reset-tax="${taxName}" data-reset-slug="${slug}">
								${termName}
							</button>
						`);
          });
        });

        resetBtnsContainer.innerHTML = fragments.join("");
        resetBtnsContainer.classList.toggle(
          "_has-buttons",
          fragments.length > 0,
        );
      }

      function fetchPosts(page = 1) {
        const ajaxurl = params.ajaxurl;
        const nonce = params.nonce;
        const POSTS_PER_PAGE = {
          post: 12,
          programs: 24,
          granters: 8,
          contest: 8,
          any: 12,
        };
        const URL_POST_TYPE_MAP = {
          post: "news",
        };

        let filterQueryString = _createFilterQueryString();
        let l = lang != "uk" ? "/" + lang : "";
        const urlParams = new URLSearchParams(filterQueryString);
        const requestPostType = postType;
        const urlPostType =
          URL_POST_TYPE_MAP[requestPostType] || requestPostType;
        const filterParamsString = urlParams.toString();
        const pagePath = page > 1 ? `page/${page}/` : "";
        const newQueryString = filterParamsString
          ? `?${filterParamsString}`
          : "";
        const basePath = window.location.pathname.replace(
          /\/page\/\d+\/?$/i,
          "/",
        );
        const newUrl =
          window.location.origin + basePath + pagePath + newQueryString;

        let data = {
          nonce: nonce,
          action: "filters",
          postType: requestPostType,
          postsPerPage: currentTerm ? 8 : POSTS_PER_PAGE[requestPostType],
          checkedIDs: checkedIDs, //  {"publication-year": ["2022, 2023"], "gender": ["zhinka"]}
          paged: page,
          urlParam: filterQueryString, //  /deceased-journalists/?publication-year=2022&gender=zhinka
          currentTax: currentTax,
          currentTerm: currentTerm,
          titleTag: titleTag,
          hideProgram,
          showMaterialType: true,
        };

        $.ajax({
          url: ajaxurl,
          data,
          type: "POST",
          beforeSend: function () {
            $(".loader-wrap").removeClass("_hide");
            $(".fetch-results").addClass("_loading");
          },
          complete: function () {
            $(".loader-wrap").addClass("_hide");
            $(".fetch-results").removeClass("_loading");
          },
          success: function (res) {
            if (res.posts !== "") {
              $(".fetch-results").html(res.posts);
            }

            if (!res.pagination) {
              $moreButton.hide();
            } else {
              $moreButton.show();
            }

            $(".pagination").html(res.pagination);
            window.history.replaceState({}, "", newUrl);
          },
        });
      }

      if ($(".fetch-results").length) {
        _checkActiveFilters();
      }
    },

    formValidation() {
      const emailInput = document.querySelector("form .wpcf7-email");
      const submitInput = document.querySelector("form .wpcf7-submit");

      function isValidEmail(email) {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(email);
      }

      emailInput?.addEventListener("input", () => {
        const email = emailInput.value.trim();

        if (email === "") {
          submitInput.classList.remove("valid");
        } else if (isValidEmail(email)) {
          submitInput.classList.add("valid");
        } else {
          submitInput.classList.remove("valid");
        }
      });
    },

    teamToc() {
      const navLinks = document.querySelectorAll(".js-sidenav__link");
      const sections = document.querySelectorAll(".js-sidenav__section");

      if (!navLinks.length || !sections.length) return;

      const idFromLink = (a) => {
        const href = a.getAttribute("href");
        if (!href) return "";
        const i = href.indexOf("#");
        if (i === -1) return "";
        return decodeURIComponent(href.slice(i + 1));
      };

      const setActive = (id) => {
        if (!id) return;
        navLinks.forEach((link) => {
          link.classList.toggle("active", idFromLink(link) === id);
          if (idFromLink(link) === id) {
            $(link)[0].scrollIntoView({
              behavior: "smooth",
              inline: "nearest",
              block: "nearest",
            });
          }
        });
      };

      const getOffsetPx = () => {
        let offset = 157;

        if (
          window.innerWidth < 1280 &&
          document.querySelector(".js-sidenav__trigger")
        ) {
          offset += 52;
        }

        return offset;
      };

      let currentActiveId = "";
      let ticking = false;

      const getActiveSectionId = () => {
        let activeId = "";
        const offsetPx = getOffsetPx();

        sections.forEach((section) => {
          if (!section.id) return;

          const { top } = section.getBoundingClientRect();
          if (top <= offsetPx) {
            activeId = section.id;
          }
        });

        if (activeId) {
          return activeId;
        }

        return sections[0].id || "";
      };

      const updateActiveSection = () => {
        const nextActiveId = getActiveSectionId();
        if (nextActiveId && nextActiveId !== currentActiveId) {
          currentActiveId = nextActiveId;
          setActive(currentActiveId);
        }
      };

      const onScrollOrResize = () => {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          updateActiveSection();
          ticking = false;
        });
      };

      updateActiveSection();
      window.addEventListener("scroll", onScrollOrResize, { passive: true });
      window.addEventListener("resize", onScrollOrResize);
    },

    navSidebarInit() {
      const $trigger = $(".js-sidenav__trigger"),
        $nav = $trigger.siblings(".js-sidenav__nav"),
        $wrap = $nav.parents(".sidenav");

      $(".js-sidenav__link").on("click", function () {
        $nav.removeClass("show");
        $(this)[0].scrollIntoView({
          behavior: "smooth",
          inline: "nearest",
          block: "nearest",
        });
      });

      $(document).on("click", function (e) {
        if (!$wrap.is(e.target) && $wrap.has(e.target).length === 0) {
          $nav.removeClass("show");
        }
      });

      $trigger.on("click", function (e) {
        e.stopPropagation();
        $nav.toggleClass("show");
      });
    },

    publicationsLoaderInit() {
      $(document).on("click", ".js-news-load-more", function () {
        const $button = $(this);
        const $wrapper = $button.parents(".js-news-button-wrap");
        const $content = $wrapper.siblings(".js-news-cards");
        const $filter = $(".archive-filter");

        if ($button.hasClass("is-loading")) {
          return;
        }

        $button.addClass("is-loading").prop("disabled", true);
        $content.attr("aria-busy", "true");

        const postIds = $button.attr("data-post-ids");

        const data = {
          action: "load_more_publications",
          per_page: parseInt($button.attr("data-per-page"), 10) || 8,
          nonce: params.nonce,
        };

        if (postIds) {
          data.offset = parseInt($button.attr("data-offset"), 10) || 0;
          data.post_ids = postIds;
        } else {
          data.page = $button.attr("data-page");
          data.cpt = $button.attr("data-cpt") || "post";
          data.current_tax = $button.attr("data-current-tax");
          data.current_term = $button.attr("data-current-term");
          data.category = $button.attr("data-category");
          data.post_tag = $button.attr("data-post-tag");
          data.nonce = params.nonce;
          data.filters = {};

          $filter.find(".archive-filter__taxonomy").each(function () {
            const tax = $(this).data("tax");
            const activeTerm = $(this)
              .find(".js-filter-option-button.is-active")
              .data("term-slug");

            if (tax && activeTerm && activeTerm !== "all") {
              data.filters[tax] = activeTerm;
            }
          });
        }

        $.ajax({
          url: params.ajaxurl,
          data,
          type: "POST",
          success: function (response) {
            $content.append(response.data.html);

            if (postIds) {
              $button.attr("data-offset", response.data.new_offset);
            } else {
              $button.attr("data-page", response.data.next_page);
            }

            if (!response.data.has_more) {
              // $wrapper.remove();
              $button.hide();
            } else {
              $button.show();
            }
          },
          complete() {
            $button.removeClass("is-loading").prop("disabled", false);
            $content.attr("aria-busy", "false");
          },
          error: function (error) {
            $button.removeClass("is-loading").prop("disabled", false);
          },
        });
      });
    },

    timelineInit() {
      function updateTimelineEventParity() {
        const $allEvents = $(".history-event");
        $allEvents.removeClass(function (index, className) {
          return (className.match(/(^|\s)_odd-\d+/g) || []).join(" ");
        });
        $allEvents.removeClass("_odd");

        const $events = $(
          ".history-event:not(.history-year__more .history-event), " +
            ".history-year._expanded .history-year__more .history-event",
        );

        let oddIndex = 0;
        $events.each((index, item) => {
          if (index % 2 === 0) {
            oddIndex++;
            const variant = ((oddIndex - 1) % 3) + 1;
            $(item).addClass(`_odd _odd-${variant}`);
          }
        });
      }

      $(".js-events-toggle").on("click", function () {
        const $button = $(this),
          $year = $button.closest(".history-year"),
          $more = $year.find(".history-year__more");

        $year.toggleClass("_expanded");

        const isExpanded = $year.hasClass("_expanded");
        $button.attr("aria-expanded", isExpanded ? "true" : "false");
        $more.attr("aria-hidden", !isExpanded ? "true" : "false");

        updateTimelineEventParity();
      });

      updateTimelineEventParity();
    },

    init() {
      Scripts.headerScroll();
      Scripts.headerScripts();
      Scripts.itemsObserver();
      Scripts.initSliders();
      Scripts.spollers();
      Scripts.copyValue();
      Scripts.filters();
      // Scripts.formValidation();
      Scripts.teamToc();
      Scripts.navSidebarInit();
      Scripts.publicationsLoaderInit();
      Scripts.timelineInit();
    },
  };

  $(document).ready(function () {
    Scripts.init();
  });
});
